// extracted by mini-css-extract-plugin
export default {"otpGroup":"custom-otp-input_otpGroup__iT9Cl","otpInput":"custom-otp-input_otpInput__uwQXd"};